import { render, staticRenderFns } from "./advanceIndividualShareHoldersSettings.vue?vue&type=template&id=6b780ebe"
import script from "./advanceIndividualShareHoldersSettings.vue?vue&type=script&lang=js"
export * from "./advanceIndividualShareHoldersSettings.vue?vue&type=script&lang=js"
import style0 from "./advanceIndividualShareHoldersSettings.vue?vue&type=style&index=0&id=6b780ebe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports